import { Classes, Icon, NonIdealState } from '@blueprintjs/core';
import cx from 'classnames';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom';

import LoadingScreen from '@f/components/shared/loading-screen/LoadingScreen';
import { getRequest } from '@f/services/batch-search/batch-search.actions';
import { CenteredContainer } from '@f/components/shared/centered-container/CenteredContainer';

import cls from './SingleBatchSearchPage.module.css';
import { ResultPage } from './pages/ResultPage';
import { SearchResultListPage } from './pages/SearchResultListPage';

export default function SingleBatchSearchPage() {
  const match = useRouteMatch();
  const dispatch = useDispatch();

  const { id, request, isGetting, gettingError } = useSelector(state => {
    const { batchSearchId: id } = match.params;

    const requestState = state.batchSearch.request;
    const request = requestState.data[id];
    const isGetting = requestState.get.processing > 0;
    const gettingError = requestState.get.error;

    return {
      id,
      request,
      isGetting,
      gettingError,
    };
  });

  useEffect(() => {
    dispatch(getRequest(id));
  }, []);

  if (!request && isGetting) {
    return (
      <div className={cls.page}>
        <LoadingScreen caption="Loading search..." />
      </div>
    );
  }

  if (!request || gettingError) {
    return (
      <CenteredContainer>
        <NonIdealState
          title="Not found"
          description="Search results have not been found."
          icon="circle"
          action={
            <NavLink className={cx(Classes.BUTTON, Classes.LARGE)} to="/dashboard/batch">
              <Icon icon="double-chevron-left" />
              <span className={Classes.BUTTON_TEXT}>Back to the list</span>
            </NavLink>
          }
        />
      </CenteredContainer>
    );
  }

  const { isRemoved } = request;

  return (
    <div className={cls.page}>
      {!isRemoved && (
        <Switch>
          <Route exact path={match.path} component={SearchResultListPage} />
          <Route exact path={`${match.path}/result/:batchSearchResultId`} component={ResultPage} />
        </Switch>
      )}

      {isRemoved && <NonIdealState title="No results" description="Search results have been removed." icon="trash" />}
    </div>
  );
}
